// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__212ES","spinner":"Spinner_spinner__2hA9w"};